import { useGetLocale } from '@legacy/components/global/LocaleProvider';
import { formatTime } from '@legacy/utils/time';

interface EditableCellProps {
  displayValue: number;
  unitType?: string;
}

const TotalColumnRenderer = ({ displayValue, unitType }: EditableCellProps) => {
  const siteLocale = useGetLocale();

  return `${formatTime(displayValue || '0', siteLocale)}${
    unitType && unitType === 'percentages' ? ' %' : ''
  }`;
};

export default TotalColumnRenderer;
